module.exports = __webpack_public_path__ + "static/Product-Summary-P5-Indoor-d95ca700b9d435f3eb865a0a986f40ad.jpg";